var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-icon",on:{"click":_vm.goBack}},[_c('v-btn',{attrs:{"icon":"","color":"purple accent-2","x-large":""}},[_c('v-icon',[_vm._v("mdi-chevron-left")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }